import { render, staticRenderFns } from "./BuilderExplorer.vue?vue&type=template&id=f15165c4&scoped=true&"
import script from "./BuilderExplorer.vue?vue&type=script&lang=js&"
export * from "./BuilderExplorer.vue?vue&type=script&lang=js&"
import style0 from "./BuilderExplorer.vue?vue&type=style&index=0&id=f15165c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15165c4",
  null
  
)

export default component.exports